import React, { useState } from 'react'
import Container from '../../components/Container'
import Table from '../../components/Table'
import Tabs from '../../components/Tabs'
import {
  getCompaniesDashboard,
  getLeadsAvailable,
  getLeadsCompleted,
  getLeadsInWork,
} from '../../api/Api'
import { FetchDataType } from '../Leads'

interface CompaniesType {
  rating: string
  years_in_service: string
  new_messages: string
  completed: string
  new_notification: string
  in_progress: string
  new_today: string
  available_to_buy: string
  clients: {
    new: string
    all: string
  }
  reviews: {
    new: string
    all: string
  }
}

interface CompaniesDataType {
  newCompanies: CompaniesType[]
  allCompanies: CompaniesType[]
  deletedCompanies: CompaniesType[]
}

const objectToElement = (element: any): JSX.Element => (
  <>
    new: {element.new} <br /> all: {element.all}
  </>
)

const arrayToTableData = (array: any[]) =>
  array.map(item => ({
    ...item,
    clients: objectToElement(item.clients),
    reviews: objectToElement(item.reviews),
  }))

const Companies: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [companiesData, setCompaniesData] = useState<CompaniesDataType>({
    newCompanies: [],
    allCompanies: [],
    deletedCompanies: [],
  })

  const columns = {
    rating: {
      title: 'Rating',
    },
    years_in_service: {
      title: 'Years in service',
    },
    new_messages: {
      title: 'New message',
    },
    completed: {
      title: 'Completed',
    },
    new_notification: {
      title: 'New notification',
    },
    in_progress: {
      title: 'In progress',
    },
    new_today: {
      title: 'New today',
    },
    available_to_buy: {
      title: 'Available to buy',
    },
    clients: {
      title: 'Clients',
    },
    reviews: {
      title: 'Reviews',
    },
  }
  const tabs = [
    {
      key: 'newCompanies',
      title: 'New Companies',
      content: (
        <Table
          items={arrayToTableData(companiesData.newCompanies)}
          columns={columns}
        />
      ),
    },
    {
      key: 'allCompanies',
      title: 'All Companies',
      content: (
        <Table
          items={arrayToTableData(companiesData.allCompanies)}
          columns={columns}
        />
      ),
    },
    {
      key: 'deletedCompanies',
      title: 'Deleted Companies',
      content: (
        <Table
          items={arrayToTableData(companiesData.deletedCompanies)}
          columns={columns}
        />
      ),
    },
  ]

  const onClickTab = async (name: string) => {
    switch (name) {
      case 'newCompanies':
        break

      case 'allCompanies':
        setIsLoading(true)
        getCompaniesDashboard()
          .then(({ data }) => {
            setCompaniesData(prevCompanies => ({
              ...prevCompanies,
              allCompanies: [
                {
                  rating: data.rating,
                  years_in_service: data.years_in_service,
                  new_messages: data.new_messages,
                  completed: data.completed,
                  new_notification: data.new_notification,
                  in_progress: data.in_progress,
                  new_today: data.new_today,
                  available_to_buy: data.available_to_buy,
                  clients: data.clients,
                  reviews: data.reviews,
                },
              ],
            }))
          })
          .finally(() => setIsLoading(false))
        break

      case 'deletedCompanies':
        break

      default:
        break
    }
  }

  return (
    <Container title="Companies">
      <Tabs
        defaultActiveKey="newCompanies"
        tabs={tabs}
        onClickTab={onClickTab}
        isLoading={isLoading}
      />
    </Container>
  )
}

export default Companies
